import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useProjects } from '../../contexts/ProjectContext'
import { getTableSortSettings } from '../../utils/settings'
import { Project } from '../../types'
import { NavItem, ShowMorePill } from './sidebarPrimitives'
import { ForgeSourceIcon } from '../icons/forgeBrandIcons'

const VISIBLE_COUNT = 5

export default function GlobalProjectList() {
  const navigate = useNavigate()
  const location = useLocation()
  const { projects } = useProjects()
  const [showAll, setShowAll] = useState(false)
  const [sortKey, setSortKey] = useState(() => getTableSortSettings('projects', 'projects-list'))

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'settings.json') {
        setSortKey(getTableSortSettings('projects', 'projects-list'))
      }
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  if (projects.length === 0) return null

  const sorted = [...projects].sort((a: Project, b: Project) => {
    let cmp = 0
    switch (sortKey?.column) {
      case 'name':
        cmp = a.name.localeCompare(b.name)
        break
      case 'updated_at':
        cmp = new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime()
        break
      case 'environment_count':
        cmp = a.environment_count - b.environment_count
        break
      default:
        cmp = 0
    }
    return sortKey?.reverse ? -cmp : cmp
  })

  const visible = showAll ? sorted : sorted.slice(0, VISIBLE_COUNT)
  const hasMore = projects.length > VISIBLE_COUNT

  return (
    <>
      {visible.map((project) => {
        const active =
          location.pathname === `/project/${project.id}` ||
          location.pathname.startsWith(`/project/${project.id}/`)
        return (
          <NavItem
            key={project.id}
            text={project.name}
            title={project.name}
            icon={
              <ForgeSourceIcon
                provider={project.git_provider}
                connected={project.repository_count > 0}
                fontSize={18}
                inheritColor
                tooltip={false}
              />
            }
            active={active}
            onClick={() => navigate(`/project/${project.id}`)}
            fontSize="0.8125rem"
          />
        )
      })}
      {hasMore && (
        <ShowMorePill
          expanded={showAll}
          hiddenCount={projects.length - VISIBLE_COUNT}
          onClick={() => setShowAll((v) => !v)}
        />
      )}
    </>
  )
}
